(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/make-payment.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/make-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const packageConfig = svs.gamePackage.data.packageConfig;
const getProductName = svs.numbergames.productMapping.getProductName;
const joinWithPunctuation = svs.tur.pay.utils.format_text.joinWithPunctuation;
const accountSelector = svs.numbergames.accountSelector;
const checkAndShowSyndicateTermsDialogAsync = svs.syndicate.rules_and_terms.checkAndShowSyndicateTermsDialogAsync;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const INVALID_ACCOUNT_SELECTED = svs.numbergames.accountSelector.constants.errors.INVALID_ACCOUNT_SELECTED;
const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  apiCalls = _svs$tur$pay.api_calls,
  communication = _svs$tur$pay.communication,
  dialogs = _svs$tur$pay.dialogs,
  misc = _svs$tur$pay.misc,
  utils = _svs$tur$pay.utils;
const _svs$gamePackage$pay = svs.gamePackage.pay,
  toApiWagers = _svs$gamePackage$pay.toApiWagers,
  handlePayResponse = _svs$gamePackage$pay.handlePayResponse,
  trackPayment = _svs$gamePackage$pay.trackPayment,
  drawClosedDialog = _svs$gamePackage$pay.drawClosedDialog;
const currency = svs.utils.format.Currency;
function setPackageSizeParam(_ref) {
  let next = _ref.next,
    sizeParam = _ref.sizeParam;
  svs.utils.paramHandler.set({
    key: 'bag',
    value: sizeParam
  });
  next();
}
function calculateActualPaidPrice(_ref2) {
  let next = _ref2.next,
    successfulWagers = _ref2.successfulWagers,
    successfulTickets = _ref2.successfulTickets;
  const wagersPrice = (sum, _ref3) => {
    let wagerAmounts = _ref3.wagerAmounts;
    return sum + svs.utils.format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  };
  const ticketsPrice = (sum, _ref4) => {
    let price = _ref4.price;
    return sum + price;
  };
  next({
    actualPaidPrice: successfulWagers.reduce(wagersPrice, 0) + successfulTickets.reduce(ticketsPrice, 0)
  });
}
function removeGamesFromLocalStorage(_ref5) {
  let next = _ref5.next,
    activeIndex = _ref5.activeIndex;
  const dispatch = svs.gamePackage.redux.store.dispatch;
  const updateIndex = svs.gamePackage.redux.gamePackageSlice.actions.updateIndex;
  svs.gamePackage.redux.middlewares.removeGamesFromLocalStorage({
    index: activeIndex,
    onRemoved: () => {
      dispatch(updateIndex({
        activeIndex
      }));
    }
  });
  next();
}
async function activeAccount(_ref6) {
  let next = _ref6.next;
  svs.ui.loader.show();
  let account;
  try {
    account = await accountSelector.getActiveAccount();
  } catch (error) {
    if (error.type === INVALID_ACCOUNT_SELECTED) {
      svs.gamePackage.logger.warn('AccountSelector reported that the user tried to play with an inactive or non existing syndicate, falling back to players account', error);
    } else {
      svs.gamePackage.logger.warn('Error when getting selected account from AccountSeletor component, falling back to players account', error);
    }
    try {
      account = await accountSelector.usePlayerAccount();
    } catch (err) {
      svs.gamePackage.logger.warn('AccountSelector was unable to revert to using the players account, using static fallback', err);
      account = {
        isSyndicate: false
      };
    }
  }
  svs.ui.loader.hide();
  const isSyndicate = account.isSyndicate;
  const syndicate = {
    syndicateId: isSyndicate ? parseInt(account.id, 10) : account.id,
    syndicateName: account.name,
    playableAmount: account.balance
  };
  next({
    syndicate,
    isSyndicate
  });
}
async function checkSyndicateTerms(_ref7) {
  let next = _ref7.next,
    isSyndicate = _ref7.isSyndicate;
  if (isSyndicate) {
    await checkAndShowSyndicateTermsDialogAsync();
  }
  next();
}
function calculateNewBalance(_ref8) {
  let next = _ref8.next,
    accountBalance = _ref8.accountBalance,
    actualPaidPrice = _ref8.actualPaidPrice,
    syndicate = _ref8.syndicate,
    isSyndicate = _ref8.isSyndicate;
  let currentBalance;
  if (isSyndicate) {
    currentBalance = syndicate.playableAmount;
  } else {
    currentBalance = currencyFromJupiterString(accountBalance);
  }
  next({
    newBalance: currentBalance - actualPaidPrice
  });
}
async function updateAccountBalance(_ref9) {
  let next = _ref9.next,
    newBalance = _ref9.newBalance,
    syndicate = _ref9.syndicate,
    isSyndicate = _ref9.isSyndicate;
  if (isSyndicate) {
    svs.ui.loader.show();
    try {
      await accountSelector.updateAccountBalance({
        accountId: syndicate.syndicateId,
        balance: newBalance
      });
    } catch (error) {
      svs.gamePackage.logger.warn("AccountSelector was not able to update balance after purchase for accountId: ".concat(syndicate.id, ", new balance was: ").concat(newBalance, "."), error);
    }
    svs.ui.loader.hide();
  } else {
    svs.components.account_balance.set(newBalance);
  }
  next();
}
function makePayment() {
  let _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onSuccess = _ref0.onSuccess;
  const product = packageConfig.title;
  const _svs$gamePackage$redu = svs.gamePackage.redux.store.getState(),
    gamePackage = _svs$gamePackage$redu.gamePackage,
    tickets = _svs$gamePackage$redu.tickets,
    numbergames = _svs$gamePackage$redu.numbergames;
  const sizes = gamePackage.sizes,
    activeIndex = gamePackage.activeIndex;
  const sizeParam = packageConfig.packageSizes[activeIndex].packageKey;
  const _sizes$activeIndex = sizes[activeIndex],
    label = _sizes$activeIndex.label,
    price = _sizes$activeIndex.price,
    gamePackageId = _sizes$activeIndex.gamePackageId;
  const uniqueProducts = [...new Set(numbergames.games.map(game => getProductName(game.productId)))];
  let syndicate;
  let isSyndicate;
  let draws;
  let wagers;
  let accountBalance;
  let regWagerResults;
  let successfulWagers;
  let incompleteWagers;
  let failedWagers;
  let drawIsClosed;
  let closedProductItsIds;
  let successfulTickets;
  let failedTickets;
  let actualPaidPrice;
  let grassrootsReceivers;
  let newBalance;
  let payAfterDeposit;
  const calls = [{
    in: () => ({
      sizeParam
    }),
    fn: setPackageSizeParam
  }, {
    in: () => ({
      price,
      product,
      drawCount: 1
    }),
    fn: accountServices.playerSession
  }, {
    fn: activeAccount,
    out: args => {
      var _args = args;
      syndicate = _args.syndicate;
      isSyndicate = _args.isSyndicate;
      return _args;
    }
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: checkSyndicateTerms
  }, {
    in: () => ({
      gamePackageId,
      isSyndicate,
      syndicate
    }),
    fn: toApiWagers,
    out: args => {
      var _args2 = args;
      draws = _args2.draws;
      wagers = _args2.wagers;
      return _args2;
    }
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price,
      isSyndicate,
      syndicate
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args3 = args;
      accountBalance = _args3.accountBalance;
      return _args3;
    }
  }, {
    fn: _ref1 => {
      let next = _ref1.next;
      payAfterDeposit = svs.utils.paramHandler.get({
        key: 'afterpay'
      }).value;
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
      next({
        payAfterDeposit
      });
    }
  }, {
    in: () => ({
      accountBalance,
      isSyndicate,
      syndicate,
      price,
      product,
      payAfterDeposit
    }),
    fn: args => {
      const confirmPaymentMessage = tickets.games.length ? "".concat(joinWithPunctuation(uniqueProducts), " g\xE5r att annullera.") : 'Spelen går att annullera.';
      const confirmPaymentOptions = {
        title: "".concat(payAfterDeposit ? 'Din insättning är klar.<br>' : '', "Vill du betala ett ").concat(isSyndicate ? 'lag' : '', "spel p\xE5 ").concat(product, "\xA0").concat(label, " f\xF6r\xA0").concat(currency(price), "\xA0kr?"),
        messages: [confirmPaymentMessage]
      };
      dialogs.confirmPayment(_objectSpread(_objectSpread({}, args), confirmPaymentOptions));
    }
  }, {
    in: () => ({
      wagers
    }),
    fn: apiCalls.payMultipleWagers,
    out: args => {
      var _args4 = args;
      regWagerResults = _args4.regWagerResults;
      return _args4;
    }
  }, {
    in: () => ({
      regWagerResults,
      wagers,
      successfulWagers,
      failedWagers
    }),
    fn: handlePayResponse,
    out: args => {
      var _args5 = args;
      drawIsClosed = _args5.drawIsClosed;
      closedProductItsIds = _args5.closedProductItsIds;
      incompleteWagers = _args5.incompleteWagers;
      successfulWagers = _args5.successfulWagers;
      failedWagers = _args5.failedWagers;
      return _args5;
    }
  }, function handleDrawClosed() {
    if (drawIsClosed) {
      return {
        calls: [{
          in: () => ({
            gamePackageId,
            isSyndicate,
            syndicate
          }),
          fn: toApiWagers,
          out: args => {
            var _args6 = args;
            draws = _args6.draws;
            wagers = _args6.wagers;
            return _args6;
          }
        }, {
          in: () => ({
            closedProductItsIds,
            draws
          }),
          fn: drawClosedDialog
        }, {
          in: () => ({
            wagers
          }),
          fn: apiCalls.payMultipleWagers,
          out: args => {
            var _args7 = args;
            regWagerResults = _args7.regWagerResults;
            return _args7;
          }
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => {
            var _args8 = args;
            drawIsClosed = _args8.drawIsClosed;
            closedProductItsIds = _args8.closedProductItsIds;
            incompleteWagers = _args8.incompleteWagers;
            successfulWagers = _args8.successfulWagers;
            failedWagers = _args8.failedWagers;
            return _args8;
          }
        }, handleDrawClosed]
      };
    }
  }, function handleIncompleteWagers() {
    if (Array.isArray(incompleteWagers) && incompleteWagers.length) {
      return {
        calls: [{
          in: () => ({
            wagers: incompleteWagers
          }),
          fn: apiCalls.payMultipleWagers,
          out: args => {
            var _args9 = args;
            regWagerResults = _args9.regWagerResults;
            return _args9;
          }
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => {
            var _args0 = args;
            incompleteWagers = _args0.incompleteWagers;
            successfulWagers = _args0.successfulWagers;
            failedWagers = _args0.failedWagers;
            return _args0;
          }
        }, handleIncompleteWagers]
      };
    }
  }, {
    in: () => ({
      ticket: tickets.games[0],
      channel: sizeParam
    }),
    fn: apiCalls.payTicket,
    out: args => {
      var _args1 = args;
      successfulTickets = _args1.successfulTickets;
      failedTickets = _args1.failedTickets;
      return _args1;
    }
  }, {
    in: () => ({
      successfulWagers,
      successfulTickets
    }),
    fn: calculateActualPaidPrice,
    out: args => {
      var _args10 = args;
      actualPaidPrice = _args10.actualPaidPrice;
      return _args10;
    }
  }, {
    in: () => ({
      product,
      price,
      actualPaidPrice,
      successfulWagers
    }),
    fn: trackPayment
  }, {
    in: () => ({
      activeIndex
    }),
    fn: removeGamesFromLocalStorage
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: misc.getGrassrootsReceivers,
    out: args => {
      var _args11 = args;
      grassrootsReceivers = _args11.grassrootsReceivers;
      return _args11;
    }
  }, {
    in: () => ({
      title: dialogs.getSuccessTitle({
        product,
        isSyndicate,
        failedWagers,
        failedTickets
      }),
      messages: dialogs.getSuccessMessages({
        product,
        successfulTickets,
        isSyndicate,
        failedWagers,
        price: actualPaidPrice,
        grassrootsReceivers,
        failedTickets
      }),
      isSyndicate,
      product,
      successfulTickets
    }),
    fn: dialogs.paymentSuccess
  }, {
    in: () => ({
      accountBalance,
      actualPaidPrice,
      syndicate,
      isSyndicate
    }),
    fn: calculateNewBalance,
    out: args => {
      var _args12 = args;
      newBalance = _args12.newBalance;
      return _args12;
    }
  }, {
    in: () => ({
      newBalance,
      syndicate,
      isSyndicate
    }),
    fn: updateAccountBalance
  }, {
    fn: _ref10 => {
      let next = _ref10.next;
      utils.logPaymentResults({
        successfulTickets,
        failedTickets,
        successfulWagers,
        failedWagers
      });
      next();
    }
  }, {
    in: () => ({
      product,
      packagedProducts: uniqueProducts
    }),
    fn: communication.correctionEmail
  }, {
    fn: misc.showGrassrootsToaster
  }];
  const cleanup = () => {
    svs.utils.paramHandler.remove({
      key: 'bag'
    });
  };
  svs.tur.pay.initPay({
    calls,
    done: () => {
      onSuccess && onSuccess({
        newBalance
      });
      cleanup();
    },
    cancel: cleanup
  });
}
svs.gamePackage.pay.makePayment = makePayment;

 })(window);